module.exports = __webpack_public_path__ + "media/stylesheets/images/mypage/right-arrow@2x-c2bddbe053eb767bbeb890fac25ed775.png";